import { gql } from "@apollo/client";

export const ORGANIZATION_FRAGMENT = gql`
  fragment Organization on Organization {
    id
    name
  }
`;
